<template>
<div :style="{ 'background-color': bss.background_color, 'overflow': 'auto',
  'position' : 'absolute',
  'top' : '0px',
    'right' : '0px',
  'bottom':'0px',
  'left':'0px', 'overflow-x': 'hidden'}">
  <link v-if="!loading && bss.font_family" rel="stylesheet" :href="'https://fonts.googleapis.com/css?family=' + bss.font_family">
  <link v-if="!loading && bss.font_family_card" rel="stylesheet" :href="'https://fonts.googleapis.com/css?family=' + bss.font_family_card">
  <loading-panel :loading="loading"></loading-panel>
  <not-found-page v-show="notFound"></not-found-page>

  <div v-if="is_paid_in_full" v-show="!loading">
    <div class="container mt-5">
      <div class="row justify-content-between">
        <div class="col-9">
          <h3 :style="{'font-family': bss.font_family, 'color': bss.text_color}" class="card-title">
            {{ $t('payment_request.thankYouForPayment') }}
          </h3>
          <p :style="{'font-family': bss.font_family, 'color': bss.text_color}">
            {{ $t('payment_request.thankYouDescription') }}
          </p>
        </div>
        <div class="col text-right">
          <p :style="{'font-family': bss.font_family, 'color': bss.text_color}">{{bss.company_name}}</p>
          <p :style="{'font-family': bss.font_family, 'color': bss.text_color}">{{ $t('payment_request.transaction') }} #{{transaction.order_number}}</p>
        </div>
      </div>
    </div>

    <div class="container mt-3">
      <card :style="{ 'background-color': bss.card_color}">
        <h4 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="card-title">{{ $t('payment_request.yourPurchases') }}
        </h4>
        <div class="row mt-5" v-for="(b, i) in bookings" :key="i + 'A'">
          <div style="width: 80px; margin-left: 20px;">
            <img :style="{'object-fit': b.object_fit || 'cover'}" :src="b.url"/>
          </div>
          <div class="col">
            <h4 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{b.name}}</h4>
            <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
              <i class="tim-icons icon-calendar-60"></i> {{getDate(b.booking_date)}}
              <i class="tim-icons el-icon-alarm-clock"></i> {{getTime(b.start_time)}}</p>
            <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
              {{ $t('payment_request.groupSize') }}: {{b.group_size}}</p>
          </div>
        </div>
        <div class="row" v-for="(gc, index) in gift_cards" :key="'GC' + index">
          <div class="col-3">
            <img class="game-img" style="object-fit: contain" :src="gc.design_url"/>
          </div>
          <div class="col-9">
            <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">{{ $t('payment_request.giftCard') }}
            </p>
            <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{ $t('payment_request.quantity') }}:</span> 1</p>
            <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{ $t('payment_request.giftCardValue') }}:</span> {{getCurrencySymbol(locale.currency)}}{{getAmount(gc.total)}} {{getCurrencyCode(locale.currency)}}</p>
          </div>
        </div>
        <div class="row mt-2" v-for="(item, index) in items" :key="'ITEM' + index">
          <div class="col-3">
            <img class="game-img" :src="item.url"/>
          </div>
          <div class="col-9">
            <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">{{item.name}}
            </p>
            <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{ $t('payment_request.quantity') }}:</span> {{item.quantity}}</p>
            <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{ $t('payment_request.price') }}:</span> {{getCurrencySymbol(locale.currency)}}{{getAmount(item.amount)}} {{getCurrencyCode(locale.currency)}}</p>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col">
            <base-button :disabled="loading"
                         :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color }"
                         v-on:click="goHome()" type="primary" simple >
              {{ $t('payment_request.visitOurWebsite') }}</base-button>
            <base-button class="ml-2" v-if="bss.display_waiver_link && bss.waivers_enabled"
                         :disabled="loading"
                         :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color }"
                         v-on:click="goToWaiver()" type="primary" simple >
              {{ $t('payment_request.checkIn') }}</base-button>
          </div>
        </div>
      </card>
    </div>
  </div>
  <div v-if="!is_paid_in_full"  v-show="!loading">
    <div class="container mt-5">
      <div class="row justify-content-center">
        <div class="col-9">
          <h3 :style="{'font-family': bss.font_family, 'color': bss.text_color}" class="card-title">{{ $t('payment_request.addPayment') }}
          </h3>
        </div>
        <div class="col text-right">
          <p :style="{'font-family': bss.font_family, 'color': bss.text_color}">{{bss.company_name}}</p>
          <p :style="{'font-family': bss.font_family, 'color': bss.text_color}">{{ $t('payment_request.transaction') }} #{{transaction.order_number}}</p>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-5">
        <card :style="{ 'background-color': bss.card_color}">
          <h4 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="card-title">
            {{ $t('payment_request.yourInformation') }}
          </h4>
          <div class="row">
            <div :style="{ 'color': bss.text_color_card}" class="col-12 col-lg-6">
              <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('payment_request.firstName') }}</label>
              <base-input :secondary-color="bss.text_color_card" :error="errs.first_name"
                          :input-style="{'color': bss.text_color_card}" :placeholder="$t('payment_request.firstName')" v-model="user.first_name"></base-input>
            </div>
            <div :style="{ 'color': bss.text_color_card}" class="col-12 col-lg-6">
              <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('payment_request.lastName') }}</label>
              <base-input :secondary-color="bss.text_color_card" :error="errs.last_name" :input-style="{'color': bss.text_color_card}" :placeholder="$t('payment_request.lastName')" v-model="user.last_name"></base-input>
            </div>
          </div>
          <div :style="{ 'color': bss.text_color_card}" class="row">
            <div class="col-12 col-lg-6">
              <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('payment_request.email') }}</label>
              <base-input :secondary-color="bss.text_color_card" :error="errs.email || (emailBlurred ? emailTypoWarning(user.email) : '')" :input-style="{'color': bss.text_color_card}" placeholder="example@gmail.com" v-model="user.email" type="email" @blur="emailBlurred = true"></base-input>
            </div>
            <div class="col-12 col-lg-6">
              <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('payment_request.phone') }}</label>
              <base-input
                :secondary-color="bss.text_color_card"
                :error="errs.phone || (user.phoneBlurred ? user.phoneValidationMessage : '')"
                :input-style="{'color': bss.text_color_card}">
                <phone-number-input :input-style="{'color': bss.text_color_card}" ref="phoneInput"
                  v-model="user.phone" @phone-update="handlePhoneUpdate"
                  :default-country="country.code || 'US'"
                  @blur="user.phoneBlurred = true"
                />
              </base-input>
            </div>
          </div>
        </card>

        <card :style="{ 'background-color': bss.card_color}" v-if="hasVisibleCustomFields">
          <h4 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="card-title">
            {{ $t('payment_request.additionalInformation') }}
          </h4>
          <div :style="{ 'color': bss.text_color_card}" class="row" v-for="(cf, i) in custom_fields" :key="'CF' + i">
            <div class="col mb-3" v-if="cf.type === 1 && isFieldVisibile(cf)">
              <base-checkbox v-on:input="handleCustomFieldInput(cf)" :key="jj"
                             :border-color="bss.button_color" :accent-color="bss.button_color"
                             :check-mark-color="bss.card_color"
                             v-model="cf.customer_response"
                             simple size="sm">
                            <span :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{cf.label}}</span>
                            <span v-for="(el, i) in cf.external_links" :key="'EL'+ i">
                    <a v-on:click="recordInteraction(el)" :style="{'font-family': bss.font_family_card, 'color': bss.link_color}" target="_blank" :href="el.link"> {{el.link_text}}</a>
                  </span>
                            <span v-for="(p, i) in cf.policies" :key="'PLI' + i">
                    <base-button :style="{'font-family': bss.font_family_card, 'color': bss.link_color}"
                                 style="font-weight:300; font-size: small; padding: 0"
                                 size="sm" link class="btn btn-link" href="" v-on:click="openPolicy(p, cf)">{{p.policy_link_text}}
                    </base-button>
                  </span>
                            <span :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" v-if="cf.required || (cf.type === 1 && cf.interaction_required)">*</span>
              </base-checkbox>
              <p :style="{'font-family': bss.font_family_card, 'color': '#ec250d'}" class="ml-4" v-if="cf.error">
                {{ cf.error }}</p>
            </div>
            <modal :show.sync="modals.policy"
                   body-classes="p-0"
                   modal-classes="modal-dialog-centered modal-lg">
              <card :style="{ 'background-color': bss.background_color}"
                    header-classes="bg-white pb-5"
                    class="border-0 mb-0">

                <p :style="{'color': bss.text_color}" v-html="selectedPolicy.policy"></p>
                <div class="row mt-3 justify-content-center">
                  <div class="col text-center">
                    <base-button
                      :style="{ 'width': '100%', 'font-family': bss.font_family_card,
                            'border-color': bss.text_color, 'color': bss.text_color }" simple
                      v-on:click="agreeToPolicy()">{{ $t('payment_request.agree') }}</base-button>
                  </div>
                </div>
              </card>
            </modal>
            <modal :show.sync="modals.dropdown_popup"
                   body-classes="p-0"
                   modal-classes="modal-dialog-centered modal-lg">
              <card :style="{ 'background-color': bss.background_color}"
                    header-classes="bg-white pb-5"
                    class="border-0 mb-0">
                <h4 v-if="popupOption" :style="{'font-family': bss.font_family_card, 'color': bss.text_color}">{{ popupOption.name }}</h4>
                <div v-if="popupOption" :style="{'color': bss.text_color, 'font-family': bss.font_family_card}" v-html="popupOption.description"></div>
                <div class="row mt-3 justify-content-center">
                  <div class="col text-center">
                    <base-button
                      :style="{ 'width': '100%', 'font-family': bss.font_family_card,
                      'border-color': bss.button_color, 'color': bss.button_color }" simple
                      v-on:click="modals.dropdown_popup = false">OK</base-button>
                  </div>
                </div>
              </card>
            </modal>
            <div class="col mb-3" v-if="cf.type === 2 && isFieldVisibile(cf)">
              <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{cf.label}}<span v-if="cf.required">*</span>
              </label>
              <base-input :secondary-color="bss.text_color_card" :error="cf.error" :input-style="{'color': bss.text_color_card}"
                          v-model="cf.customer_response">

              </base-input>
            </div>
            <div class="col mb-3" v-if="cf.type === 5 && isFieldVisibile(cf)">
              <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{cf.label}}<span v-if="cf.required">*</span>
              </label>
              <base-input :secondary-color="bss.text_color_card" :error="cf.error" :input-style="{'color': bss.text_color_card}">
                <textarea :style="{'color': bss.text_color_card}" class="form-control" rows="4" v-model="cf.customer_response"></textarea>
              </base-input>
            </div>
            <div class="col mb-3" v-if="cf.type === 3 && isFieldVisibile(cf)">
              <div class="row">
                <div class="col-lg-6">
                  <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{cf.label}}<span v-if="cf.required">*</span>
                  </label>
                  <base-input :secondary-color="bss.text_color_card" :placeholder="$t('payment_request.select')" :error="cf.error">
                    <base-dropdown :key="'CFF' + j" :style="{'font-family': bss.font_family_card }"
                                   title-classes="form-group form-control" :text-color="bss.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                   :font-family="bss.font_family_card"
                                   :title="getDropDownLabel(cf.customer_response)"
                    >
                      <a v-for="(c, i) in cf.dropdown_options"  :style="{'font-family': bss.font_family_card }"
                         style="white-space: normal; overflow-wrap: break-word;"
                         class="dropdown-item" href="#" :key="'DOJ' + i" v-on:click.prevent="selectDropdown(cf, c)">
                        {{ getDropDownLabel(c) }}</a>
                    </base-dropdown>
                  </base-input>
                </div>
                <div class="col" v-if="cf.customer_response">
                  <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{cf.customer_response.follow_up_field_label}}
                    <span v-if="cf.required && cf.customer_response.has_follow_up_field">*</span>
                  </label>
                  <base-input :secondary-color="bss.text_color_card" :input-style="{'color': bss.text_color_card}" v-model="cf.customer_response.follow_up_response"
                              v-if="cf.customer_response && cf.customer_response.has_follow_up_field"></base-input>
                </div>
              </div>
            </div>
          </div>
        </card>

        <card :style="{ 'background-color': bss.card_color}">
          <h4 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="card-title">
            {{ $t('payment_request.paymentOptions') }}
          </h4>
          <div class="row">
            <div class="col-lg-6">
              <base-input :secondary-color="bss.text_color_card" :placeholder="$t('payment_request.select')">
                <base-dropdown  :style="{'font-family': bss.font_family_card }"
                                title-classes="form-group form-control" :text-color="bss.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                :font-family="bss.font_family_card"
                                :title="payment_option_title"
                >
                  <a v-if="!require_deposit" :style="{'font-family': bss.font_family_card }" style="white-space: normal; overflow-wrap: break-word;"
                     class="dropdown-item" href="#"  v-on:click.prevent="updatePaymentAmount('full')">
                    {{ $t('payment_request.payFullAmount') }} -
                    {{getCurrencySymbol(locale.currency)}}{{getAmount(transaction.due)}}{{getCurrencyCode(locale.currency)}}</a>
                  <a  v-if="deposit > 0" :style="{'font-family': bss.font_family_card }" style="white-space: normal; overflow-wrap: break-word;"
                     class="dropdown-item" href="#"  v-on:click.prevent="updatePaymentAmount('deposit')">
                    {{ $t('payment_request.payDeposit') }} -
                    {{getCurrencySymbol(locale.currency)}}{{getAmount(deposit)}} {{getCurrencyCode(locale.currency)}}
                  </a>
                  <a v-if="payment_settings.payment_request_allow_custom_amounts" :style="{'font-family': bss.font_family_card }" style="white-space: normal; overflow-wrap: break-word;"
                      class="dropdown-item" href="#"  v-on:click.prevent="updatePaymentAmount('partial')">
                    {{ $t('payment_request.payCustomAmount') }}
                  </a>
                </base-dropdown>
              </base-input>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <label v-show="payment_option === 'partial'"
                     :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('payment_request.amount') }} ({{getCurrencySymbol(locale.currency)}})</label>
              <base-input :input-style="{'color': bss.text_color_card}"
                          :secondary-color="bss.text_color_card"
              :error="errs.amount" v-on:focusout="updatePaymentAmount('partial')" placeholder="0"
              v-show="payment_option === 'partial'" v-model.number="partial_amount"></base-input>
            </div>
          </div>
        </card>
        <card :style="{ 'background-color': bss.card_color}" v-show="transaction.due > 0">
          <h4 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="card-title">
            {{ $t('payment_request.paymentMethod') }}
          </h4>
          <div class="row" v-if="payment_settings.payment_layout_type === 'dropdown'">
            <div class="col-lg-6">
              <base-input :secondary-color="bss.text_color_card" :placeholder="$t('payment_request.select')">
                <base-dropdown  :style="{'font-family': bss.font_family_card }"
                                title-classes="form-group form-control" :text-color="bss.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                :font-family="bss.font_family_card"
                                :title="selectedPaymentOption.display_name"
                >
                  <a v-for="(pm, i) in payment_methods" :key="'PM' + i" :style="{'font-family': bss.font_family_card }" style="white-space: normal; overflow-wrap: break-word;"
                     class="dropdown-item" href="#"  v-on:click.prevent="setPaymentOption(pm)">
                    {{ pm.display_name }}</a>
                </base-dropdown>
              </base-input>
            </div>
          </div>

          <div class="row mb-3" v-if="payment_settings.payment_layout_type === 'buttons'">
            <div class="col">
              <div class="payment-methods-buttons">
                <div class="button-group">
                  <button
                    v-for="(pm, i) in payment_methods"
                    :key="'PM' + i"
                    type="button"
                    class="payment-btn"
                    :class="{ 'active': selectedPaymentOption.id === pm.id }"
                    :style="{
                                fontFamily: bss.font_family_card,
                                backgroundColor: selectedPaymentOption.id === pm.id ? bss.button_color : 'transparent',
                                color: selectedPaymentOption.id === pm.id ? '#fff' : bss.button_color,
                                borderColor: bss.button_color
                              }"
                    @click="setPaymentOption(pm)"
                  >
                    {{ pm.display_name }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="selectedPaymentOption.name !== 'Card' && selectedPaymentOption.name !== 'Gift card'">
            <div class="row">
              <div class="col">
                <span v-html="selectedPaymentOption.content"></span>
              </div>
            </div>
          </div>

          <div v-show="selectedPaymentOption.name === 'Card'" :key="j">
            <!--      Authorize.net (Accept.js)-->
            <div class="row mb-2" v-show="payment_settings.payment_gateway_id === 1">
              <div class="col">
                <enhanced-payment-form
                  ref="authorizePaymentForm"
                  :font-family="bss.font_family_card"
                  :text-color="bss.text_color_card"
                  :border-color="inputBorderSolid"
                  :zip-label="'Billing ' + (country.zip_label || '').toLowerCase()"
                  :zip-placeholder="country.zip_placeholder"
                  :api-login-id="payment_settings.api_name"
                  :public-client-key="payment_settings.public_client_key"
                  :is-live="!!payment_settings.is_live"
                  :show-security-indicators="false"
                />
              </div>
            </div>

            <div class="row" v-show="payment_settings.payment_gateway_id === 2">
              <div class="col">
                <!--                  Square-->
                <form id="payment-form-square">
                  <div id="card-container"></div>
                </form>
                <div id="payment-status-container"></div>
              </div>
            </div>

            <!-- Save card for future use - info text when forced by deposit requirement (Square) -->
            <div class="row mb-3 mt-3" v-if="requireCardSaveForced && payment_settings.payment_gateway_id === 2 && payment_settings.store_credit_card">
              <div class="col">
                <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'opacity': '0.7', 'font-size': '0.85em', 'margin-bottom': '0'}">
                  <i class="tim-icons icon-lock-circle mr-1"></i>
                  {{$t('payment_request.cardWillBeSaved') || 'Your card will be saved on file for the remaining balance.'}}
                </p>
              </div>
            </div>
            <!-- Save card for future use checkbox (Square) -->
            <div class="row mb-3 mt-3" v-if="!requireCardSaveForced && payment_settings.payment_gateway_id === 2 && payment_settings.store_credit_card">
              <div class="col">
                <base-checkbox
                  v-model="save_card_for_future"
                  :border-color="bss.button_color"
                  :accent-color="bss.button_color"
                  :check-mark-color="bss.card_color"
                  simple
                  size="sm">
                  <span :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                    {{ $t('payment_request.saveCardForFuture') || 'Save my payment method for future purchases' }}
                  </span>
                </base-checkbox>
              </div>
            </div>

            <!--        Stripe-->
            <div class="row" v-show="payment_settings.payment_gateway_id === 3">
              <div class="col">
                <form id="payment-form">
                  <div id="payment-element">
                    <!--Stripe.js injects the Payment Element-->
                  </div>
                  <div id="payment-message" class="hidden"></div>
                </form>
              </div>
            </div>

            <!-- Save card for future use - info text when forced by deposit requirement (Stripe) -->
            <div class="row mb-3 mt-3" v-if="requireCardSaveForced && payment_settings.payment_gateway_id === 3 && payment_settings.store_credit_card">
              <div class="col">
                <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'opacity': '0.7', 'font-size': '0.85em', 'margin-bottom': '0'}">
                  <i class="tim-icons icon-lock-circle mr-1"></i>
                  {{$t('payment_request.cardWillBeSaved') || 'Your card will be saved on file for the remaining balance.'}}
                </p>
              </div>
            </div>
            <!-- Save card for future use checkbox (Stripe only) -->
            <div class="row mb-3 mt-3" v-if="!requireCardSaveForced && payment_settings.payment_gateway_id === 3 && payment_settings.store_credit_card">
              <div class="col">
                <base-checkbox
                  v-model="save_card_for_future"
                  :border-color="bss.button_color"
                  :accent-color="bss.button_color"
                  :check-mark-color="bss.card_color"
                  simple
                  size="sm">
                  <span :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                    {{ $t('payment_request.saveCardForFuture') || 'Save my payment method for future purchases' }}
                  </span>
                </base-checkbox>
              </div>
            </div>
          </div>

          <div class="row" v-if="selectedPaymentOption.name === 'Gift card'">
            <div class="col">
              <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('payment_request.giftCardCode') }}</label>
              <base-input :secondary-color="bss.text_color_card" :input-style="{'color': bss.text_color_card}"
                :placeholder="$t('payment_request.giftCardCode')"  v-model="gift_card_code" :error="errs.gift_card_code">
              </base-input>
            </div>
          </div>

          <div class="row" v-if="payment_settings.payment_gateway_id === 5 && selectedPaymentOption.name === 'Yappy'">
            <div class="col">
              <base-button style="width: 100%" v-on:click="payWithYappy()"
                           simple :style="{ 'font-family': bss.font_family_card, 'border-color':
                                    bss.button_color, 'color': bss.button_color }">
                {{ $t('payment_request.payWith') }} <img class="ml-2" src="https://pagosbg.bgeneral.com/assets/img/yappy-logo-brand.svg">
              </base-button>
            </div>
          </div>

          <div class="row" v-show="selectedPaymentOption.name === 'Gift card' || selectedPaymentOption.name === 'Card'">
            <div class="col">
              <base-button :disabled="disable_submit"
                           :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color }"
                           v-on:click="payButtonClick()" type="primary" simple >
                {{ wallet_pending ? (wallet_pending_method === 'apple_pay' ? $t('book.buttons.confirmWithApplePay') : $t('book.buttons.confirmWithGooglePay')) : $t('payment_request.submitPayment') }}</base-button>
            </div>
          </div>
        </card>
      </div>
      <div class="col-lg-3 col">
        <card :style="{ 'background-color': bss.card_color }">
          <div class="row">
            <div class="col-11">
              <h4 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="card-title">{{ $t('payment_request.yourPurchases') }}
              </h4>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <div class="row" v-for="(c, index) in bookings" :key="'M' + index">
                <div class="col-3">
                  <img class="game-img" :style="{'object-fit': c.object_fit || 'cover'}" :src="c.url"/>
                </div>
                <div class="col-9">
                  <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">{{c.name}}
                  </p>
                  <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{ $t('payment_request.date') }}:</span> {{getDayOfWeek(c.booking_date)}} {{getFormattedDate(locale.date_format, c.booking_date)}}</p>
                  <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{ $t('payment_request.time') }}:</span> {{getTime(c.start_time)}}</p>
                  <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{ $t('payment_request.quantity') }}:</span> {{c.group_size}}</p>
                  <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{ $t('payment_request.bookingSubtotal') }}:</span> {{getCurrencySymbol(locale.currency)}}{{getAmount(c.subtotal)}} {{getCurrencyCode(locale.currency)}}</p>
                </div>
              </div>

              <div class="row" v-for="(gc, index) in gift_cards" :key="'GC' + index">
                <div class="col-3">
                  <img class="game-img" style="object-fit: contain" :src="gc.design_url"/>
                </div>
                <div class="col-9">
                  <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">{{ $t('payment_request.giftCard') }}
                  </p>
                  <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{ $t('payment_request.quantity') }}:</span> 1</p>
                  <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{ $t('payment_request.giftCardValue') }}:</span> {{getCurrencySymbol(locale.currency)}}{{getAmount(gc.total)}} {{getCurrencyCode(locale.currency)}}</p>
                </div>
              </div>
              <div class="row mt-2" v-for="(item, index) in items" :key="'ITEM' + index">
                <div class="col-3">
                  <img class="game-img" :src="item.url"/>
                </div>
                <div class="col-9">
                  <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">{{item.name}}
                  </p>
                  <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{ $t('payment_request.quantity') }}:</span> {{item.quantity}}</p>
                  <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{ $t('payment_request.price') }}:</span> {{getCurrencySymbol(locale.currency)}}{{getAmount(item.amount)}} {{getCurrencyCode(locale.currency)}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3" v-if="payment_settings.show_promo_code_field === 1">
            <div class="col">
              <div style="display: flex; width: 100%;">
                <base-input :secondary-color="bss.text_color_card" v-model="promo_code"
                            style="flex-grow: 1; border-radius: 0px;"
                            :input-style="{'border-color': 'var(--input-border-color, #7d7d7d99)', 'color': bss.text_color_card,
                              'border-radius': '5px 0px 0px 5px'}"
                            :placeholder="bss.promo_code_placeholder_text">
                </base-input>
                <base-button simple style="flex-grow: 0; border-radius: 0px 5px 5px 0px; border-left: none;"
                             :style="{ 'font-family': bss.font_family_card,
                         'background-color': bss.card_color,
                         'margin-left': '0px', 'margin-top': '0px', 'margin-bottom': '10px',
                         'padding-top': '0px', 'padding-bottom': '0px',
                         'padding-left': '10px', 'padding-right': '10px',
                         'border-color': 'var(--input-border-color, #7d7d7d99)', 'color': bss.button_color }"
                             v-on:click="applyPromo()">
                  {{ $t('payment_request.apply') }}
                </base-button>
              </div>
            </div>
          </div>

          <div class="row" v-if="payment_settings.allow_tipping
                  && ((payment_settings.allow_preset_tipping_options && tipping_options.length > 0)
                  || payment_settings.allow_custom_tipping_options)">
            <div class="col">
              <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{payment_settings.tip_label}}</label>
              <base-input :secondary-color="bss.text_color_card" v-if="payment_settings.allow_preset_tipping_options && tipping_options.length > 0">
                <base-dropdown :style="{'font-family': bss.font_family_card }"
                               title-classes="form-group form-control" :text-color="bss.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                               :font-family="bss.font_family_card"
                               :title="tip_title"
                >
                  <a v-for="(t, i) in tipping_options"  :style="{'font-family': bss.font_family_card }"
                     style="white-space: normal; overflow-wrap: break-word;"
                     class="dropdown-item" href="#" :key="'T' + i" v-on:click.prevent="computeTip(t)">
                    {{ getTipAmount(t) }}</a>
                </base-dropdown>
              </base-input>

              <div style="display: flex; width: 100%;">
                <base-input
                  v-if="(payment_settings.allow_custom_tipping_options && !payment_settings.allow_preset_tipping_options) || selectedCustomTipOption"
                  :secondary-color="bss.text_color_card" v-model.number="applied_tip_amount"
                  style="flex-grow: 1; border-radius: 0px;"
                  :input-style="{'border-color': 'var(--input-border-color, #7d7d7d99)', 'color': bss.text_color_card,
                              'border-radius': '5px 0px 0px 5px'}"
                  :placeholder="tip_placeholder">
                </base-input>
                <base-button v-if="(payment_settings.allow_custom_tipping_options && !payment_settings.allow_preset_tipping_options) || selectedCustomTipOption"
                             simple style="flex-grow: 0; border-radius: 0px 5px 5px 0px; border-left: none;"
                             :style="{ 'font-family': bss.font_family_card,
                         'background-color': bss.card_color,
                         'margin-left': '0px', 'margin-top': '0px', 'margin-bottom': '10px',
                         'padding-top': '0px', 'padding-bottom': '0px',
                         'padding-left': '10px', 'padding-right': '10px',
                         'border-color': 'var(--input-border-color, #7d7d7d99)', 'color': bss.button_color }"
                             v-on:click="computeTip({id: 0, name: $t('book.customAmount'), amount: applied_tip_amount, value_type: payment_settings.custom_tipping_value_type})">
                  {{$t('book.apply')}}
                </base-button>
              </div>
            </div>
          </div>

          <hr :style="{ 'background-color': bss.text_color_card}">
          <div class="row">
            <div class="col">
              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('payment_request.subtotal') }}</p>
            </div>
            <div class="col" >
              <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getCurrencySymbol(locale.currency)}}{{getAmount(transaction.price)}} {{getCurrencyCode(locale.currency)}}</p>
            </div>
          </div>
          <div class="row" v-for="(t, i) in taxes" :key="'T' + i" v-if="(t.pricing_type === 0 || (t.pricing_type === 1 && t.show_tax_line_items))">
            <div class="col">
              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ t.name }}
                <span v-if="t.pricing_type === 1"> (included)</span>
              </p>
            </div>
            <div class="col">
              <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getCurrencySymbol(locale.currency)}}{{getAmount(t.amount)}} {{getCurrencyCode(locale.currency)}}</p>
            </div>
          </div>

          <div class="row" v-if="Number(transaction.inclusive_tax_waived) > 0">
            <div class="col">
              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('payment_request.includedTaxWaived') }}</p>
            </div>
            <div class="col">
              <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">-{{getCurrencySymbol(locale.currency)}}{{getAmount(transaction.inclusive_tax_waived)}} {{getCurrencyCode(locale.currency)}}</p>
            </div>
          </div>

          <div class="row" v-for="(f, i) in fees" :key="'K' + i">
            <div class="col">
              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ f.name }}</p>
            </div>
            <div class="col">
              <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getCurrencySymbol(locale.currency)}}{{getAmount(f.amount, f.value_type)}} {{getCurrencyCode(locale.currency)}}</p>
            </div>
          </div>

          <div class="row" v-for="(tips, i) in tips" :key="'TIPS' + i + jj">
            <div class="col">
              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ payment_settings.tip_line_item_label }}
                <i v-on:click="removeTip(tips)" class="tim-icons icon-simple-remove" v-if="!tips.hasOwnProperty('id')" style="cursor: pointer"></i>
              </p>
            </div>
            <div class="col">
              <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getCurrencySymbol(locale.currency)}}{{getAmount(tips.amount)}} {{getCurrencyCode(locale.currency)}}</p>
            </div>
          </div>

          <div class="row" v-for="(p, i) in promo_codes" :key="pc_key + i">
            <div class="col-6">
              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ p.name }}
              </p>
            </div>
            <div class="col">
              <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">-{{getCurrencySymbol(locale.currency)}}{{getAmount(p.amount)}} {{getCurrencyCode(locale.currency)}}</p>
            </div>
          </div>


          <hr :style="{ 'background-color': bss.text_color_card}">
          <div class="row">
            <div class="col">
              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('payment_request.total') }}</p>
            </div>
            <div class="col" >
              <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getCurrencySymbol(locale.currency)}}{{getAmount(transaction.total)}} {{getCurrencyCode(locale.currency)}}</p>
            </div>
          </div>

          <div class="row" v-if="bookings.length > 0 && deposit > 0">
            <div class="col">
              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'font-weight': 'bold'}">{{ $t('payment_request.depositDue') }}</p>
            </div>
            <div class="col" >
              <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'font-weight': 'bold'}">{{getCurrencySymbol(locale.currency)}}{{getAmount(deposit)}} {{getCurrencyCode(locale.currency)}}</p>
            </div>
          </div>

          <div class="row" v-if="bookings.length > 0 && deposit > 0">
            <div class="col">
              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('payment_request.amountDue') }}</p>
            </div>
            <div class="col" >
              <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getCurrencySymbol(locale.currency)}}{{getAmount(transaction.due)}} {{getCurrencyCode(locale.currency)}}</p>
            </div>
          </div>

          <div class="row" v-else>
            <div class="col">
              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'font-weight': 'bold'}">{{ $t('payment_request.amountDue') }}</p>
            </div>
            <div class="col" >
              <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'font-weight': 'bold'}">{{getCurrencySymbol(locale.currency)}}{{getAmount(transaction.due)}} {{getCurrencyCode(locale.currency)}}</p>
            </div>
          </div>


        </card>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {API_LOCATION} from "@/api-config";
import axios from "axios";
import BaseRadio from "@/components/Inputs/BaseRadio";
import _ from "lodash";
import currencies from "@/assets/currencies.json";
import countries from "@/assets/countries.json";
import NotFoundPage from "../../pages/GeneralViews/NotFoundPage";
import swal from "sweetalert2";
import {dayOfWeek, formattedDate, time} from "@/plugins/dateFormatter";
import { v4 as uuidv4 } from 'uuid';
import PhoneNumberInput from '@/components/PhoneNumberInput.vue';
import EnhancedPaymentForm from "@/components/Payments/EnhancedPaymentForm";
import { isValidEmail } from '@/util/emailValidator';
import emailTypoWarning from '@/mixins/emailTypoWarning';
import { inputBorderColor, inputBorderColorSolid, sdkPalette } from '@/util/bookingTheme';
import { setLocale, applyPageLocale } from '@/i18n';

export default {
  name: "PaymentPage",
  components: {BaseRadio, NotFoundPage, PhoneNumberInput, EnhancedPaymentForm},
  mixins: [emailTypoWarning],
  data(){
    return {
      selectedCf: '',
      tipping_options: [],
      applied_tip_amount: '',
      applied_tip: 0,
      tip_title: this.$t('book.tipAmount'),
      tip_placeholder: this.$t('book.tipAmountPercent'),
      selectedCustomTipOption: false,
      payment_option_title: '',
      payment_methods: [],
      selectedPaymentOption: '',
      require_deposit: false,
      payment_intent_id: '',
      disable_submit: false,
      selectedPolicy: '',
      modals: { policy: false, dropdown_popup: false },
      popupOption: null,
      custom_fields: [],
      promo_code: '',
      promo_codes: [],
      pc_key: 0,
      time_format: '',
      date_format: '',
      is_paid_in_full: false,
      currencies: currencies.currencies,
      loading: false,
      notFound: false,
      hash: '',
      transaction: '',
      bss: '',
      apply_promo: false,
      bookings: [],
      taxes: [],
      fees: [],
      items: [],
      tips: [],
      gift_cards: [],
      payment_settings: '',
      save_card_for_future: false,
      locale: '',
      country: '',
      countries: countries.countries,
      payment_option: 'full',
      partial_amount: 0,
      stripe_payment_method: 'card',
      wallet_pending: false,
      wallet_pending_method: null,
      gift_card_code: '',
      errs: {
        gift_card_code: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        terms: '',
        amount: ''
      },
      emailBlurred: false,
      user: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        phoneE164: '',
        phoneValidationStatus: 'valid',
        phoneValidationMessage: '',
        phoneBlurred: false
      },
      payment: {
        amount: '',
        cardNumber: '',
        expirationDate: '',
        cardCode: '',
        zip: '',
        cardholder_first_name: '',
        cardholder_last_name: '',
      },
      authorize_opaque_data: null,
      card: '',
      elements: '',
      stripe: '',
      square: '',
      squareAppId: '',
      squareLocationId: '',
      deposit: 0,
      j: 0,
      jj: 0
    }
  },
  computed: {
    // Opaque input-border color for payment SDKs / inline gateway styles
    // (Stripe appearance, Square card style, Authorize.net inputs) which can't
    // read the --input-border-color CSS var.
    inputBorderSolid() {
      return inputBorderColorSolid(this.bss)
    },
    requireCardSaveForced() {
      if (!this.payment_settings.store_credit_card) return false
      // Mandatory deposit + venue-side deposit flag → no choice, info text shown
      if (this.payment_settings.require_card_for_deposit && this.require_deposit) return true
      // Customer paying the full balance + venue-side full-payment flag → no
      // choice, info text shown. Doesn't apply to 'partial' (custom amount) or
      // 'deposit' branches.
      if (this.payment_settings.require_card_for_full_payment && this.payment_option === 'full') return true
      // Cross-product: both flags on + opted-in optional deposit → no escape
      // (switching to 'full' would just hit the full-payment force), info text shown
      if (this.payment_settings.require_card_for_deposit && this.payment_settings.require_card_for_full_payment && this.payment_option === 'deposit') return true
      return false
    },
    hasVisibleCustomFields() {
      return (this.custom_fields || []).some(cf => this.isFieldVisibile(cf))
    },
  },
  watch: {
    partial_amount() {
      this.invalidateWalletPending()
    },
    payment_option(newVal) {
      this.invalidateWalletPending()
      if (newVal === 'deposit' && this.payment_settings.require_card_for_deposit && !this.save_card_for_future) {
        this.$nextTick(() => { this.save_card_for_future = true })
      } else if (newVal === 'full' && this.payment_settings.require_card_for_full_payment && !this.save_card_for_future) {
        this.$nextTick(() => { this.save_card_for_future = true })
      }
    },
    save_card_for_future(newVal) {
      if (newVal) return
      if (this.requireCardSaveForced) {
        // No graceful escape: re-force on next tick.
        this.$nextTick(() => { this.save_card_for_future = true })
        return
      }
      // Legacy escape: unchecking save while in optional-deposit mode reverts to
      // full payment. Skip if full payment also requires save.
      if (this.payment_settings.require_card_for_deposit && this.payment_option === 'deposit' && !this.require_deposit && !this.payment_settings.require_card_for_full_payment) {
        this.updatePaymentAmount('full')
      }
    },
  },
  methods: {
    removeTip(tip){
      _.remove(this.tips, {
        custom_id: tip.custom_id
      });
      const tipAmount = parseFloat(tip.amount) || 0
      this.transaction.total = Number(Math.round(Number((parseFloat(this.transaction.total) - tipAmount) + 'e2')) + 'e-2')
      this.transaction.due = Number(Math.round(Number((parseFloat(this.transaction.due) - tipAmount) + 'e2')) + 'e-2')
      this.jj++
      if (this.payment_settings.payment_gateway_id === 3) {
        this.initializeStripe()
      }
    },
    computeTip(tip){
      if(tip.id === 0 && !this.selectedCustomTipOption && this.payment_settings.allow_preset_tipping_options){
        this.tip_title = tip.name
        this.selectedCustomTipOption = true
        return
      } else {
        this.selectedCustomTipOption = false
      }
      if(tip.amount === '' || tip.amount === null || tip.amount === undefined || isNaN(parseFloat(tip.amount))){
        tip.amount = ''
        return
      }
      if(tip.value_type === 0){
        this.tip_title = tip.name + ' ' + tip.amount + '%'
        const tipRaw = parseFloat(this.transaction.price) * parseFloat(tip.amount) * 0.01
        this.applied_tip = Number(Math.round(Number(tipRaw + 'e2')) + 'e-2')
      } else {
        this.tip_title = tip.name + ' ' + this.getCurrencySymbol(this.locale.currency) + this.roundToFixed(tip.amount, 2) + this.getCurrencyCode(this.locale.currency)
        this.applied_tip = parseFloat(tip.amount)
      }

      this.tips.push({ amount: this.applied_tip, removable: true, custom_id: uuidv4()})
      this.transaction.total = Number(Math.round(Number((parseFloat(this.transaction.total) + this.applied_tip) + 'e2')) + 'e-2')
      this.transaction.due = Number(Math.round(Number((parseFloat(this.transaction.due) + this.applied_tip) + 'e2')) + 'e-2')


      if(this.payment_settings.payment_gateway_id === 3){
        this.initializeStripe()
      }
    },
    roundToFixed(num, decimals) {
      if (num == null || isNaN(num)) {
        return (0).toFixed(decimals);
      }
      // JS toString switches to scientific notation for very small numbers (~< 1e-7).
      // Concatenating 'e' + decimals onto a string like '2.84e-14' produces invalid
      // scientific notation ('2.84e-14e2'), which Number() turns into NaN.
      // Sub-half-unit values are below display precision anyway, so snap to 0.
      const halfUnit = Math.pow(10, -(decimals + 1)) * 5
      if (Math.abs(num) < halfUnit) {
        return (0).toFixed(decimals);
      }
      let rounded = Math.round(Number(num + 'e' + decimals));
      return Number(rounded + 'e-' + decimals).toFixed(decimals);
    },
    getTipAmount(tip){
      if(tip.id === 0){
        return tip.name
      } else if(tip.value_type === 0){
        return tip.name + ' ' + tip.amount + '%'
      }
      return tip.name + ' ' + this.getCurrencySymbol(this.locale.currency) + this.roundToFixed(tip.amount, 2) + this.getCurrencyCode(this.locale.currency)
    },
    sanitizeNameInput(name) {
      if (!name || typeof name !== 'string') return '';

      // Normalize spacing
      name = name.trim().replace(/\s+/g, ' ');

      // Disallow email addresses
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(name)) return '';

      // Disallow phone numbers (7+ digits)
      const digitsOnly = name.replace(/[\s\-\(\)+]/g, '');
      if (/^\d{7,}$/.test(digitsOnly)) return '';

      // Require at least one valid letter (Latin or Greek)
      if (!/[a-zA-Z\u0370-\u03FF\u1F00-\u1FFF]/.test(name)) return '';

      // Disallow common bad values
      const bad = ['n/a', 'na', 'test', 'unknown', 'none'];
      if (bad.includes(name.toLowerCase())) return '';

      // Enforce length limits
      if (name.length < 2 || name.length > 100) return '';

      return name;
    },
    agreeToPolicy() {
      this.recordInteraction(this.selectedPolicy)

      // Check if all interactions are now complete
      if (this.handleCustomFieldInput(this.selectedCf)) {
        this.selectedCf.customer_response = true
        // Force re-render to update checkbox visual state
        this.$nextTick(() => {
          this.jj++
        })
      }
      this.modals.policy = false
    },
    handleCustomFieldInput(field) {
      let ready = false
      if (field.interaction_required) {
        let total_field_count = 0
        let interactive_count = 0
        let links = field.external_links

        for (let n in links) {
          total_field_count++
          if (links[n].user_interaction) {
            interactive_count++
          }
        }

        let policies = field.policies
        for (let n in policies) {
          total_field_count++
          if (policies[n].user_interaction) {
            interactive_count++
          }
        }

        if (total_field_count === interactive_count) {
          ready = true
          field.error = ""
        } else {
          ready = false
          // Force the checkbox to remain unchecked
          field.customer_response = false
          field.error = "Please read all attached policies"
          // Force re-render to update checkbox visual state
          this.$nextTick(() => {
            this.jj++
          })
        }
      } else {
        ready = true
      }
      return ready
    },
    recordInteraction(item){
      item.user_interaction = 1
    },
    isFieldVisibile(field){
      const allowed_games = field.visibility_conditions ? JSON.parse(field.visibility_conditions) : []
      const allowed_gift_card_types = field.gift_card_type_visibility_conditions ? JSON.parse(field.gift_card_type_visibility_conditions) : []

      let event_scope
      if (allowed_games.length > 0) event_scope = 'specific'
      else if (field.visibility) event_scope = 'none'
      else event_scope = 'all'

      let gift_card_scope = 'none'
      if (allowed_gift_card_types.length > 0) gift_card_scope = 'specific'
      else if (field.show_when_gift_card_in_cart) gift_card_scope = 'any'

      for (const b of this.bookings) {
        if (b.game_id) {
          if (event_scope === 'all') return true
          if (event_scope === 'specific' && _.find(allowed_games, {id: b.game_id})) return true
        }
      }
      for (const gc of this.gift_cards) {
        if (gift_card_scope === 'any') return true
        if (gift_card_scope === 'specific' && _.find(allowed_gift_card_types, {id: gc.gift_card_type_id})) return true
      }
      return false
    },
    setPaymentOption(option){
      this.invalidateWalletPending()
      if(option.name !== 'Card'){
        if(this.payment_settings.payment_gateway_id === 3){
          this.disable_submit = false
        }
      } else {
        if(this.payment_settings.payment_gateway_id === 3){
          this.disable_submit = true
        }
        if(this.payment_settings.payment_gateway_id === 2){
          this.initializeSquare()
        }
      }
      this.selectedPaymentOption = option
    },
    getDropDownLabel(item){
      if(item){
        return item.name
      }
      return ''
    },
    selectDropdown(question, option){
      question.customer_response = option
      this.jj++
      if (option.has_popup && option.description) {
        this.popupOption = option
        this.modals.dropdown_popup = true
      }
    },
    openPolicy(item, field){
      this.selectedCf = field
      this.selectedPolicy = item
      this.modals.policy = true
    },
    getFormattedDate(format, d){
      return formattedDate(format, d)
    },
    getDayOfWeek(d){
      if(this.locale.show_day_of_week){
        return dayOfWeek(d)
      }
      return ''
    },
    async applyPromo(){
      // Check for duplicates and combinability first
      for(let n in this.promo_codes){
        if(this.promo_codes[n].name === this.promo_code){
          swal(this.$t('payment_request.swals.error'), this.$t('payment_request.swals.invalidPromo'), 'error')
          return
        }
        if(this.promo_codes[n].is_combineable === 0){
          swal(this.$t('payment_request.swals.error'), this.$t('payment_request.swals.nonCombineablePromo'), 'error')
          return
        }
      }

      this.loading = true
      let code = this.bss.code
      let url = API_LOCATION + 'bookings/company-groups/' + code + '/promos-v2'

      let data = {
        promo_code_id: null,
        promo_code_name: this.promo_code,
        transaction_id: this.transaction.id,
      }

      this.axios.post(url, data)
        .then(response => {
          this.loading = false
          if(JSON.stringify(response.data.promo_code) === '{}'){
            swal({
              title: this.$t('payment_request.swals.error'),
              text: this.payment_settings.show_custom_promo_code_error_message ? this.payment_settings.promo_code_error_message : this.$t('payment_request.swals.invalidPromo'),
              type: 'error',
              confirmButtonColor: '#1d8cf8',
              confirmButtonText: 'OK'
            })
            return
          }

          const promo = response.data.promo_code
          if(promo.is_combineable === 0 && this.promo_codes.length > 0){
            swal(this.$t('payment_request.swals.error'), this.$t('payment_request.swals.nonCombineablePromo'), 'error')
            return
          }

          this.apply_promo = true
          this.promo_code = ''
          this.promo_codes.push({
            id: promo.id,
            name: promo.name,
            value_amount: promo.value_amount,
            is_combineable: promo.is_combineable
          })

          this.getTransaction()
          swal({
            title: this.$t('payment_request.swals.success'),
            text: this.$t('payment_request.swals.promoApplied'),
            type: 'success',
            showCancelButton: false
          })
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response && err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            swal({
              title: this.$t('payment_request.swals.error'),
              text: this.payment_settings.show_custom_promo_code_error_message ? this.payment_settings.promo_code_error_message : this.$t('payment_request.swals.invalidPromo'),
              type: 'error',
              confirmButtonColor: '#1d8cf8',
              confirmButtonText: 'OK'
            })
          }
        })
    },
    getDate(d){
      return formattedDate(this.date_format, d)
    },
    getTime(d) {
      return time(this.time_format, d);
    },
    goHome(){
      window.location.href = this.bss.redirect_url
    },
    goToWaiver(){
      let code = this.bss.code
      let path = '/checkin/' + code
      this.$router.push(path)
    },
    updatePaymentAmount(option){
      this.payment_option = option
      if(this.payment_option === 'full'){
        this.partial_amount = this.transaction.due

        this.payment_option_title = this.$t('payment_request.payFullAmount') + ' - ' +
          this.getCurrencySymbol(this.locale.currency) + this.getAmount(this.transaction.due)+ this.getCurrencyCode(this.locale.currency)
      } else if(this.payment_option === 'deposit'){
        this.partial_amount = this.deposit
        this.payment_option_title = this.$t('payment_request.payDeposit') + ' - ' +
          this.getCurrencySymbol(this.locale.currency) + this.getAmount(this.deposit) + this.getCurrencyCode(this.locale.currency)
      } else {
        this.payment_option_title = this.$t('payment_request.payCustomAmount')
      }
      if (this.payment_settings.payment_gateway_id === 3) {
        this.initializeStripe()
      }
    },
    isEmailValid(emailString) {
      // Use centralized email validator utility with comprehensive TLD whitelist
      return isValidEmail(emailString);
    },
    getCurrencyCode(code) {
      if (this.locale.currency_format === 1) {
        return code;
      }

      // Postfix krone currencies: the symbol goes after the amount
      if ((code === 'SEK' || code === 'DKK') && this.locale.currency_format === 0) {
        return code === 'DKK' ? 'kr.' : 'kr';
      }

      return '';
    },
    getCurrencySymbol(code) {
      if (this.locale.currency_format === 0) {
        let c = _.find(this.currencies, { code: code });
        if (!c) return '';

        // Postfix krone currencies: no prefix symbol
        if (code === 'SEK' || code === 'DKK') {
          return '';
        }
        return c.symbol;
      }
      return '';
    },
    getNumberFormat(value) {
      if (this.locale.currency === 'SEK' || this.locale.currency === 'DKK') {
        return parseFloat(value).toLocaleString(this.locale.currency === 'DKK' ? 'da-DK' : 'sv-SE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }

      // Existing logic for other currencies
      if (this.locale.number_format === 1) {
        value = value.toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.', ',');
      }
      return value;
    },
    getAmount(integer){
      if(integer == null){
        return
      }
      return this.getNumberFormat(parseFloat(integer).toFixed(2))
    },
    is_valid(){
      let errors = 0
      if(this.user.first_name == '' || this.sanitizeNameInput(this.user.first_name) === ''){
        this.errs.first_name = this.$t('checkin.errors.firstName')
        errors++
      } else {
        this.errs.first_name = ''
      }

      if(this.user.last_name == '' || this.sanitizeNameInput(this.user.last_name) === ''){
        this.errs.last_name = this.$t('checkin.errors.lastName')
        errors++
      } else {
        this.errs.last_name = ''
      }

      if(!this.isEmailValid(this.user.email)){
        this.errs.email = this.$t('payment_request.errors.email')
        errors++
      } else {
        this.errs.email = ''
      }

      if(this.user.phone == ''){
        this.errs.phone = this.$t('payment_request.errors.phone')
        errors++
      } else if(this.user.phoneValidationStatus === 'invalid') {
        this.errs.phone = this.$t('book.errors.phoneInvalid')
        errors++
      } else {
        this.errs.phone = ''
      }

      for(let n in this.custom_fields){
        const cf = this.custom_fields[n]
        const isRequired = cf.required || (cf.type === 1 && cf.interaction_required)
        if(isRequired && this.isFieldVisibile(cf) && !cf.customer_response){
          cf.error = this.$t('payment_request.errors.required')
          errors++
        } else {
          cf.error = ''
        }
      }

       if(errors > 0){
         return false
       }
       return true
    },
    is_valid_card(){
      return this.$refs.paymentForm.validateAll()
    },
    is_amount_valid(){
      if(!this.require_deposit && parseFloat(this.transaction.due) < this.partial_amount){
        this.errs.amount = this.$t('payment_request.errors.amountMoreThanTransaction')
        return false
      } else if (this.require_deposit && parseFloat(this.deposit) < this.partial_amount){
        this.errs.amount = this.$t('payment_request.errors.amountMoreThanDeposit')
        return false
      }
      this.errs.amount = ''
      return true
    },
    async handlePaystackPayment(reference, data){
      let url = API_LOCATION + 'bookings/' + this.hash
      data.paystack_reference = reference

      // Paystack has already captured this charge (onSuccess fired), so from
      // here the only failure mode is OTC not recording it. Lock the pay
      // button so a second charge cannot start, retry the callback, then poll
      // the transaction for the webhook's server-side record. Never report a
      // captured charge as declined.
      this.loading = true
      this.disable_submit = true
      const paidBefore = Number(this.transaction.paid) || 0
      const delays = [0, 2000, 4000, 6000]
      for (let attempt = 0; attempt < delays.length; attempt++) {
        if (delays[attempt]) await new Promise(resolve => setTimeout(resolve, delays[attempt]))
        try {
          await axios.post(url, data)
          this.showPaystackPaymentSuccess()
          return
        } catch (err) {
          console.log(err)
        }
      }

      // The callback could not be delivered. The webhook records the charge
      // server-side within seconds; wait for it to show on the transaction.
      const recorded = await this.waitForPaystackRecord(paidBefore)
      if (recorded) {
        this.showPaystackPaymentSuccess()
        return
      }

      // Still unconfirmed: keep the button locked. The charge is captured and
      // the webhook or the venue reconciles it.
      this.loading = false
      swal({
        title: this.$t('payment_request.swals.paymentVerifying'),
        text: this.$t('payment_request.swals.paymentVerifyingText'),
        type: 'warning',
        showCancelButton: false
      })
    },
    showPaystackPaymentSuccess(){
      this.disable_submit = false
      this.loading = false
      swal({
        title: this.$t('payment_request.swals.success'),
        text: this.$t('payment_request.swals.paymentProcessed'),
        type: 'success',
        showCancelButton: false
      }).then((response)=> {
        this.is_paid_in_full = true
      })
    },
    async waitForPaystackRecord(paidBefore){
      const url = API_LOCATION + 'bookings/' + this.hash
      for (let n = 0; n < 10; n++) {
        await new Promise(resolve => setTimeout(resolve, 3000))
        try {
          const response = await axios.get(url)
          const paidNow = Number(response.data.transaction.paid) || 0
          if (paidNow > paidBefore) {
            this.transaction = response.data.transaction
            return true
          }
        } catch (err) {
          console.log(err)
        }
      }
      return false
    },
    invalidateWalletPending(){
      if (!this.wallet_pending) return
      this.wallet_pending = false
      this.wallet_pending_method = null
      // Faithful to this page's confirm-failure pattern: no /payment/clear
      // here. The abandoned PaymentIntent is superseded by the re-init below,
      // exactly like a declined-card retry on this page.
      this.loading = false
      this.disable_submit = true
      this.stripe_payment_method = 'card'
      this.initializeStripe()
    },
    confirmWalletPayment(){
      if (!this.wallet_pending) return
      this.wallet_pending = false
      this.wallet_pending_method = null
      this.loading = true
      this.disable_submit = true
      // No await may ever be added before runStripeConfirm here: the wallet
      // sheet must open inside this tap's user-activation window.
      this.runStripeConfirm()
    },
    payButtonClick(){
      if (this.wallet_pending) {
        this.confirmWalletPayment()
      } else {
        this.createPayment()
      }
    },
    runStripeConfirm(){
      //stripe confirm payment goes here
      let elements = this.elements
      let self = this
      // Keep disable_submit=true through the Stripe redirect/Link flow so
      // the button stays disabled until confirmPayment actually resolves.
      // Resetting before confirmPayment lets customers double-submit during
      // Link's popup/redirect window and creates duplicate payment rows.
      // .finally() guarantees the guards reset even if confirmPayment rejects
      // (network error, SDK failure), otherwise the button would stay
      // disabled forever with no error surfaced.
      this.stripe.confirmPayment({
        elements,
        redirect: 'if_required',
        confirmParams: {
          // Make sure to change this to your payment completion page
          return_url: "https://offthecouch.io/",
        },
      }).then(function(result) {
        // Treat as paid only when the PaymentIntent actually succeeded (or is
        // processing for async methods the webhook will finalize). With
        // redirect:'if_required', confirmPayment resolves WITHOUT error on an
        // abandoned wallet or Link step while the intent is still at
        // requires_payment_method; that must not show a success message.
        const pi = result.paymentIntent
        const paymentSucceeded = !result.error && pi &&
          (pi.status === 'succeeded' || pi.status === 'processing')
        if (!paymentSucceeded) {
          // Inform the customer that there was an error.
          swal({
            title: self.$t('payment_request.swals.transactionFailed'),
            text: self.$t('payment_request.swals.cardDeclined'),
            type: 'error',
            showCancelButton: false,
            confirmButtonColor: '#fd5d93',
            confirmButtonText: self.$t('payment_request.swals.tryAgain')
          })
          if(self.payment_settings.payment_gateway_id === 3){
            self.initializeStripe()
          }
        } else {
          swal({
            title: self.$t('payment_request.swals.success'),
            text: self.$t('payment_request.swals.paymentProcessed'),
            type: 'success',
            showCancelButton: false
          }).then((response)=> {
            self.is_paid_in_full = true
          })
        }
      }).catch(function(err) {
        console.log('confirmPayment rejected:', err)
        swal({
          title: self.$t('payment_request.swals.transactionFailed'),
          text: self.$t('payment_request.swals.cardDeclined'),
          type: 'error',
          showCancelButton: false,
          confirmButtonColor: '#fd5d93',
          confirmButtonText: self.$t('payment_request.swals.tryAgain')
        })
        if(self.payment_settings.payment_gateway_id === 3){
          self.initializeStripe()
        }
      }).finally(function() {
        self.disable_submit = false
        self.loading = false
      });
    },
    async payWithPaystack(data) {
      // Inline v2 API. Metadata lets the paystack-webhook record this charge
      // against the transaction if the callback below never reaches the lambda;
      // the popup ignores it. The charged total includes any tip, which only
      // the callback can add to the transaction.
      const popup = new PaystackPop()
      popup.newTransaction({
        key: this.payment_settings.api_name,
        email: this.user.email,
        amount: Math.round(Number(parseFloat(data.total) + 'e2')),
        reference: ''+Math.floor((Math.random() * 1000000000) + 1),
        metadata: {
          otc: 1,
          otc_flow: 'payment_request',
          otc_transaction_id: this.transaction.id
        },
        onSuccess: (response) => {
          // The lambda reads paystack_reference.transaction (v1 field name);
          // v2 carries the numeric transaction id as response.trans (verified from a live callback).
          this.handlePaystackPayment({ ...response, transaction: response.trans }, data)
        }
      });
    },
    async payWithYappy(){
      if(!this.is_valid()){
        return
      }
      let url = API_LOCATION + 'yappy/payment-request?hash=' + this.hash

      let amount = this.transaction.due
      if(this.payment_option === 'partial'){
        if(!this.is_amount_valid()){
          return
        }
        amount = this.partial_amount
      } else if (this.payment_option === 'deposit'){
        amount = this.deposit
      }

      let custom_fields = []
      let resp = ''
      for(let n in this.custom_fields){
        if(!this.isFieldVisibile(this.custom_fields[n])) continue
        resp = this.custom_fields[n].customer_response
        if(this.custom_fields[n].type === 3 && this.custom_fields[n].customer_response){
          if(this.custom_fields[n].customer_response.has_follow_up_field){
            resp = this.custom_fields[n].customer_response.name + ': ' + this.custom_fields[n].customer_response.follow_up_response
          } else {
            resp = this.custom_fields[n].customer_response.name
          }
        }
        custom_fields.push({
          customer_response: resp,
          id: this.custom_fields[n].id,
          type: this.custom_fields[n].type
        })
      }

      let data = {
        user: {
          ...this.user,
          phone: this.user.phoneE164 || this.user.phone  // Use E.164 if available
        },
        total: amount,
        currency: this.locale.currency,
        bookings: this.bookings,
        custom_fields: custom_fields,
        locale: this.$i18n.locale
      }

      this.loading = true
      axios.post(url, data)
        .then(response => {
          this.loading = false
          window.location.href = response.data.url
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          }
        })
    },
    async createPayment(){
      if(!this.is_valid()){
        return
      }
      let url = API_LOCATION + 'bookings/' + this.hash

      let amount = this.transaction.due
      if(this.payment_option === 'partial'){
        if(!this.is_amount_valid()){
          return
        }
        amount = this.partial_amount
      } else if (this.payment_option === 'deposit'){
        amount = this.deposit
      }

      let custom_fields = []
      let resp = ''
      for(let n in this.custom_fields){
        if(!this.isFieldVisibile(this.custom_fields[n])) continue
        resp = this.custom_fields[n].customer_response
        if(this.custom_fields[n].type === 3 && this.custom_fields[n].customer_response){
          if(this.custom_fields[n].customer_response.has_follow_up_field){
            resp = this.custom_fields[n].customer_response.name + ': ' + this.custom_fields[n].customer_response.follow_up_response
          } else {
            resp = this.custom_fields[n].customer_response.name
          }
        }
        custom_fields.push({
          customer_response: resp,
          id: this.custom_fields[n].id,
          type: this.custom_fields[n].type
        })
      }

      let data = {
        user: {
          ...this.user,
          phone: this.user.phoneE164 || this.user.phone  // Use E.164 if available
        },
        total: amount,
        currency: this.locale.currency,
        bookings: this.bookings,
        custom_fields: custom_fields,
        locale: this.$i18n.locale,
        tips: this.tips.filter(tip => tip.custom_id),
        save_card_for_future: this.save_card_for_future
      }

      if (this.selectedPaymentOption.name === 'Card' && this.payment_settings.payment_gateway_id === 1){
        // Accept.js — tokenize client-side
        this.disable_submit = true
        try {
          this.authorize_opaque_data = await this.$refs.authorizePaymentForm.tokenize()
        } catch (err) {
          let msg = this.$t('payment_request.swals.transactionFailed')
          if (err.message === 'ACCEPT_JS_NOT_LOADED') {
            msg = this.$t('payment_request.swals.paymentNotReady') || 'Payment is loading, please try again.'
          } else if (err.message === 'VALIDATION_FAILED') {
            msg = this.$t('payment_request.swals.checkFields') || 'Please check your card details and try again.'
          }
          swal(this.$t('payment_request.swals.error') || 'Error', msg, 'error')
          this.disable_submit = false
          return
        }
        data.payment = {
          cardholder_first_name: this.user.first_name,
          cardholder_last_name: this.user.last_name,
          opaqueData: this.authorize_opaque_data,
          zip: this.$refs.authorizePaymentForm.zip
        }
      } else if (this.selectedPaymentOption.name === 'Card' && this.payment_settings.payment_gateway_id === 2) {
        //Square
        this.loading = true
        this.disable_submit = true
        try {
          const token = await this.tokenize(this.card);
          const verificationToken = await this.verifyBuyer(this.square, token.token, token.zip);
          const token2 = await this.tokenize(this.card);
          let payment = {
            cardholder_first_name: this.user.first_name,
            cardholder_last_name: this.user.last_name,
            locationId: this.squareLocationId,
            sourceId: token.token,
            sourceId2: token2.token,
            verificationToken: verificationToken
          }
          data.payment = payment
          data.payment.zip = token.zip
        } catch (error) {
          //Square
          this.loading = false
          this.disable_submit = false
        }
      } else if (this.selectedPaymentOption.name === 'Card' &&  this.payment_settings.payment_gateway_id === 3){

        let payment = {
          cardholder_first_name: this.user.first_name,
          cardholder_last_name: this.user.last_name
        }
        data.paymentIntent = this.payment_intent_id
        data.payment = payment
      }
      else if (this.selectedPaymentOption.name === 'Card' &&  this.payment_settings.payment_gateway_id === 4){
        let payment = {
          cardholder_first_name: this.user.first_name,
          cardholder_last_name: this.user.last_name
        }
        data.payment = payment
        let paystack = this.payWithPaystack(data)
        return
      } else if (this.selectedPaymentOption.name === 'Gift card'){
        if(this.gift_card_code === '' ){
          this.errs.gift_card_code = this.$t('payment_request.errors.giftCardCode')
          return
        } else {
          this.errs.gift_card_code = ''
        }
        data.gift_card_code = this.gift_card_code
      }
      this.loading = true
      this.disable_submit = true
      axios.post(url, data)
        .then(async response => {
          if(this.selectedPaymentOption.name === 'Card' && this.payment_settings.payment_gateway_id === 3){
            // Update PaymentIntent with setup_future_usage if checkbox is checked.
            // Non-fatal: the payment row was already created above; if this optional
            // enrichment fails, continue to confirmPayment rather than rolling back
            // the UX to "declined" while a payment row already exists.
            if (this.save_card_for_future && this.payment_intent_id) {
              try {
                let updateUrl = API_LOCATION + 'bookings/company-groups/' + this.bss.code + '/payment/stripe-payment-intent'
                await axios.post(updateUrl, {
                  paymentIntent: this.payment_intent_id,
                  total: this.partial_amount,
                  currency: this.locale.currency,
                  setup_future_usage: 'off_session'
                })
              } catch (setupErr) {
                console.log('setup_future_usage update failed:', setupErr)
              }
            }

            if (this.stripe_payment_method === 'apple_pay' || this.stripe_payment_method === 'google_pay') {
              // Wallet sheets must open inside a tap's user-activation window
              // (iOS 26 Safari enforces this), so confirm waits for a second
              // tap with no preceding async work.
              this.wallet_pending = true
              this.wallet_pending_method = this.stripe_payment_method
              this.loading = false
              this.disable_submit = false
              return
            }
            this.runStripeConfirm()
          } else {
            swal({
              title: this.$t('payment_request.swals.success'),
              text:  this.$t('payment_request.swals.paymentProcessed'),
              type: 'success',
              showCancelButton: false
            }).then((response)=> {
              this.is_paid_in_full = true
            })
            this.disable_submit = false
            this.loading = false
          }
        })
        .catch(err => {
          this.loading = false
          this.disable_submit = false
          console.log(err)
          swal({
            title:  this.$t('payment_request.swals.transactionDeclined'),
            text: this.$t('payment_request.swals.checkInfo'),
            type: 'error'
          })
        })
    },
    handlePhoneUpdate(phoneData) {
      this.user.phoneE164 = phoneData.e164;
      this.user.phoneValidationStatus = phoneData.validationStatus || 'valid';
      this.user.phoneValidationMessage = phoneData.validationMessage || '';
    },
    checkForInclusiveTaxes(){
      for(let n in this.taxes){
        if(this.taxes[n].pricing_type === 1){
          return true
        }
      }
      return false
    },
    async getTransaction(){
      let url = API_LOCATION + 'bookings/' + this.hash
      this.loading = true
      axios.get(url)
        .then(response => {
          this.transaction = response.data.transaction
          this.bss = response.data.settings
          // For now the payment page reuses the booking-site (bss) input border;
          // swap the argument when the per-page setting ships.
          document.documentElement.style.setProperty('--input-border-color', inputBorderColor(this.bss))
          this.locale = response.data.locale
          applyPageLocale(this.locale && this.locale.default_locale, this.bss && Number(this.bss.show_language_switcher) === 1)
          this.payment_settings = response.data.payment_settings
          this.bookings = response.data.bookings
          this.partial_amount = this.transaction.due
          this.taxes = response.data.taxes
          if(this.payment_settings.allow_custom_tipping_options && this.payment_settings.custom_tipping_value_type === 1){
            this.tip_placeholder = this.$t('book.tipAmount') + ' (' + this.getCurrencySymbol(this.locale.currency) + ')'
          }
          this.tipping_options = response.data.tipping_options
          if(this.payment_settings.allow_custom_tipping_options && this.payment_settings.allow_preset_tipping_options){
            this.tipping_options.push({id: 0, name: this.$t('book.customAmount'), value_type: 0, amount: 0})
          }
          if(this.transaction.receipt_subtotal != null){
            this.transaction.price = Number(this.transaction.receipt_subtotal)
          } else if(this.checkForInclusiveTaxes()){
            this.transaction.price = this.transaction.price + this.transaction.tax
          }
          this.fees = response.data.fees
          this.promo_codes = response.data.promos
          this.tips = response.data.tips
          this.items = response.data.items
          this.gift_cards = response.data.gift_cards
          this.deposit = response.data.deposit
          this.custom_fields = response.data.custom_fields
          this.custom_fields = _.orderBy(this.custom_fields, 'position')
          this.payment_methods = response.data.payment_methods
          for(let n in this.payment_methods){
            if(this.payment_methods[n].name === 'Card'){
              this.payment_methods[n].display_name = this.$t('payment_request.card')
            }
            else if(this.payment_methods[n].name === 'Gift card'){
              this.payment_methods[n].display_name = this.$tc('payment_request.giftCard', 1)
            }
            else {
              this.payment_methods[n].display_name = this.payment_methods[n].name
            }
          }

          this.selectedPaymentOption = this.payment_methods[0]

          for(let n in this.bookings){
            if(this.bookings[n].allow_deposit && this.bookings[n].require_deposit){
              this.require_deposit = true
              this.payment_option = 'deposit'
              this.partial_amount = this.deposit
            }
          }

          // Pre-check save_card_for_future when card storage is required for the
          // branch the customer is landing in.
          const willEnterDeposit = this.deposit > 0 && this.payment_settings.require_card_for_deposit
          const willEnterFullPayment = this.payment_settings.require_card_for_full_payment
          if((willEnterDeposit || willEnterFullPayment)
            && this.payment_settings.store_credit_card
            && (this.payment_settings.payment_gateway_id === 2 || this.payment_settings.payment_gateway_id === 3)){
            this.save_card_for_future = true
          }

          for(let n in this.custom_fields){
            if(this.custom_fields[n].external_links){
              this.custom_fields[n].external_links = JSON.parse(this.custom_fields[n].external_links)
            }

            if(this.custom_fields[n].policies){
              this.custom_fields[n].policies = JSON.parse(this.custom_fields[n].policies)
            }

            if(this.custom_fields[n].type === 3){
              this.custom_fields[n].dropdown_options = _.orderBy(JSON.parse(this.custom_fields[n].dropdown_options), 'id')
            }
          }

          if(!this.require_deposit && parseFloat(this.transaction.due) <= 0 && this.apply_promo == false){
            this.is_paid_in_full = true
          }
          else if(this.require_deposit && parseFloat(this.deposit) <= 0 && this.apply_promo == false){
            this.is_paid_in_full = true
          }
          else if(this.apply_promo == false){
            //Stripe
            if(this.payment_settings.payment_gateway_id === 3){
              this.loadStripe()
            }
            if(this.payment_settings.payment_gateway_id === 2){
              this.squareAppId = this.payment_settings.api_name
              this.squareLocationId = this.payment_settings.api_location
              this.loadSquare(this.payment_settings.is_live)
            }
            if(this.payment_settings.payment_gateway_id === 4){
              this.loadPaystack()
            }
          }
          //Locale
          this.country = _.find(this.countries, { code: this.locale.country })
          this.time_format = this.locale.time_format
          this.date_format = this.locale.date_format
          let payment_option = this.require_deposit ? 'deposit' : 'full'
          this.updatePaymentAmount(payment_option)
          this.loading = false
        })
        .catch(err => {
          this.notFound = true
          console.log(err)
        })
    },
    async loadPaystack(){
      const script = document.createElement('script');
      script.src = 'https://js.paystack.co/v2/inline.js'
      script.async = true;
      document.body.appendChild(script);
    },
    async loadSquare(is_live){
      const script = document.createElement('script');
      if(is_live){
        script.src = 'https://web.squarecdn.com/v1/square.js'
      } else {
        script.src = 'https://sandbox.web.squarecdn.com/v1/square.js'
      }
      script.async = true;
      document.body.appendChild(script);
      script.onload = () => {
        this.initializeSquare()
      };
    },
    async tokenize(paymentMethod) {
      const tokenResult = await paymentMethod.tokenize();
      if (tokenResult.status === 'OK') {
        const zip = tokenResult.details.billing.postalCode ? tokenResult.details.billing.postalCode : ''
        return {token: tokenResult.token, zip}
      } else {
        let errorMessage = `Tokenization failed-status: ${tokenResult.status}`;
        this.loading = false
        this.disable_submit = false
        if (tokenResult.errors) {
          errorMessage += ` and errors: ${JSON.stringify(
            tokenResult.errors
          )}`;
        }
        throw new Error(errorMessage);
      }
    },
    async initializeCard(payments) {
      const { card: cardColor, text: textColor, accent: accentColor } = sdkPalette(this.bss)
      const customStyle = {
        '.input-container.is-focus': {
          borderColor: accentColor,
        },
        '.input-container.is-error': {
          borderColor: '#ff1600',
        },
        '.message-icon': {
          color: textColor,
        },
        '.message-text.is-error': {
          color: '#ff1600',
        },
        '.message-icon.is-error': {
          color: '#ff1600',
        },
        'input.is-error': {
          color: '#ff1600',
        },
        '@media screen and (max-width: 600px)': {
          'input': {
            'fontSize': '12px',
          }
        },
        '.input-container': {
          borderColor: this.inputBorderSolid,
          // backgroundColor: this.bss.card_color,
          // color: this.bss.text_color_card,
          // 'font-family': this.bss.font_family_card,
          borderRadius: '6px',
        },
        '.message-text': {
          color: textColor,
          // 'font-family': this.bss.font_family_card
        },
        input: {
          backgroundColor: cardColor,
          color: textColor,
          fontFamily: 'helvetica neue, sans-serif',
          //fontFamily: this.bss.font_family_card
        },
        'input::placeholder': {
          color: textColor,
        },
      }
      const card = await payments.card({
        style: customStyle,
      });
      await card.attach('#card-container');
      return card;
    },
    async verifyBuyer(payments, token, zip) {
      let amount = Math.abs(this.transaction.due)
      if(this.payment_option === 'partial'){
        amount = this.partial_amount
      } else if (this.payment_option === 'deposit'){
        amount = this.deposit
      }
      const verificationDetails = {
        amount: (Math.round((amount + Number.EPSILON) * 100) / 100).toString(),
        /* collected from the buyer */
        billingContact: {
          familyName: this.user.first_name,
          givenName: this.user.last_name,
          postalCode: zip,
        },
        currencyCode: this.locale.currency,
        intent: 'CHARGE',
      };

      const verificationResults = await payments.verifyBuyer(
        token,
        verificationDetails
      );
      return verificationResults.token;
    },
    async initializeSquare(){
      if (!window.Square) {
        throw new Error('Square.js failed to load properly');
      }
      if(this.card){
        await this.card.destroy()
      }
      this.square = window.Square.payments(this.squareAppId, this.squareLocationId);
      this.square.setLocale(this.$i18n.locale)
      try {
        this.card = await this.initializeCard(this.square);
      } catch (e) {
        console.error('Initializing Card failed', e);
        return;
      }
    },
    async initializeStripe(retries = 5){
      for (let i = 0; i < retries; i++) {
        if (window.Stripe) break;
        await new Promise(r => setTimeout(r, 200)); // wait 200ms
      }

      if (!window.Stripe) {
        throw new Error('Stripe.js failed to load properly');
      }

      this.disable_submit = true
      // A Stripe Connect venue tokenizes inside its connected account (platform key + account).
      this.stripe =  window.Stripe(this.payment_settings.api_name, {
        currency: this.locale.currency.toLowerCase(),
        locale: this.$i18n.locale,
        ...(this.payment_settings.stripe_account_id ? { stripeAccount: this.payment_settings.stripe_account_id } : {})
      });
      let url = API_LOCATION + 'bookings/company-groups/' + this.bss.code + '/payment/stripe-payment-intent'

      let amount = Math.abs(this.transaction.due)
      if(this.payment_option === 'partial'){
        amount = this.partial_amount
      } else if (this.payment_option === 'deposit'){
        amount = this.deposit
      }

      let data = {
        currency: this.locale.currency,
        total: amount,
        transaction_id: this.transaction.id,
        email: this.user.email
      }

      axios.post(url, data)
        .then(response => {
          this.loading = false
          let clientSecret = response.data.clientSecret
          this.payment_intent_id = response.data.clientSecret.split('_')[0] + '_' + response.data.clientSecret.split('_')[1]
          const palette = sdkPalette(this.bss)
          const appearance = {
            theme: 'stripe',
            variables: {
              colorPrimary: palette.accent,
              colorBackground: palette.card,
              colorText: palette.text,
            },
            rules: {
              '.Input': { borderColor: this.inputBorderSolid },
              '.Input:focus': { borderColor: this.inputBorderSolid },
            },
          };
          this.elements = this.stripe.elements({ appearance, clientSecret });
          const paymentElementOptions = {
            layout: "tabs",
          };

          const paymentElement = this.elements.create("payment", paymentElementOptions);
          paymentElement.mount("#payment-element");
          paymentElement.on('change', (event) => {
            if (this.wallet_pending && event.value && event.value.type !== this.wallet_pending_method) {
              this.invalidateWalletPending()
              return
            }
            if (event.complete) {
              // Enable the payment button
              this.disable_submit = false;
            } else {
              // Disable the payment button
              this.disable_submit = true;
            }
            if (event.value) {
              this.stripe_payment_method = event.value.type
            }
          });
        })
        .catch(err => {
          if(err.response && err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            console.error('Initializing Stripe failed', err)
          }
        })
    },
    async loadStripe(){
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/';
      script.async = true;
      let self = this
      script.onload = function() {
        self.initializeStripe()
      };
      document.body.appendChild(script);
      // setTimeout(() => {
      //   this.initializeStripe()
      // }, 400)
    },
  },
  mounted() {
    this.hash = this.$route.params.hash
    this.getTransaction()
  }
}
</script>

<style scoped>
img {
  width: 60px;
  height: 60px;
  -webkit-border-radius: 60px;
  -webkit-background-clip: padding-box;
  -moz-border-radius: 60px;
  -moz-background-clip: padding;
  border-radius: 60px;
  background-clip: padding-box;
  margin: 7px 0 0 5px;
  float: left;
  background-size: cover;
  background-position: center center;
  margin-top: -7px;
  margin-bottom: -7px;
}


.payment-methods-buttons {
  width: 100%;
}

.button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.payment-btn {
  padding: 10px 20px;
  border: 1.5px solid;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  min-width: 120px;
}

.payment-btn:hover:not(.active) {
  opacity: 0.8;
  transform: translateY(-2px);
}

.payment-btn.active {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.payment-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Responsive - stack buttons on smaller screens */
@media (max-width: 576px) {
  .button-group {
    flex-direction: column;
  }

  .payment-btn {
    width: 100%;
  }
}
</style>
